export default __webpack_public_path__ + "static/media/groupBuyingDiscountEnglish.cc5246a9.png";